
const googleAuth = (function () {
  function installClient() {
    const apiUrl = 'https://apis.google.com/js/api.js'

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = apiUrl;
      script.onreadystatechange = script.onload = () => {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          resolve();
        }
      }

      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }

  function initClient(config) {
    let cfg = Object.assign({
      library: 'client:auth2'
    });

    return new Promise((resolve) => {
      window.gapi.load(cfg.library, () => {
        window.gapi
          .client
          .init(config)
          .then(() => {
            resolve(window.gapi);
          });
      });
    });
  }

  function Auth() {
    if (!(this instanceof Auth)) {
      return new Auth();
    }

    this.GoogleAuth = null /* window.gapi.auth2.getAuthInstance() */
    this.isAuthorized = false
    // console.log('1: ' + this.isAuthorized);
    this.isInit = false
    this.prompt = null
    this.isLoaded = function () {
      /* eslint-disable */
      console.warn('isLoaded() will be deprecated. You can use "this.$gAuth.isInit"')
      return !!this.GoogleAuth
    };

    this.load = (config, prompt) => {
      return installClient()
        .then(() => {
          return initClient(config)
        })
        .then((gapi) => {
          this.GoogleAuth = gapi.auth2.getAuthInstance();
          this.isInit = true
          this.prompt = prompt
          this.isAuthorized = this.GoogleAuth.isSignedIn.get();
          
          if (this.isAuthorized) {
            this.app.$root.$emit("google-logged", this.GoogleAuth.currentUser);
          }

          return this.GoogleAuth.currentUser;
        });
    };

    this.signIn = () => {
      return new Promise((resolve, reject) => {
        if (!this.GoogleAuth) {
          reject(false);
          return;
        }

        this.GoogleAuth.signIn()
          .then((googleUser) => {
            this.isAuthorized = this.GoogleAuth.isSignedIn.get();

            if (this.isAuthorized) {
              this.app.$root.$emit("google-logged", googleUser);
              resolve(googleUser);
            } else {
              reject(googleUser);
            }
          })
          .catch((error) => {
            this.app.$root.$emit("error", error);
            reject(error);
          })
      })
    };

    this.getAuthCode = () => {
      return new Promise((resolve, reject) => {
        if (!this.GoogleAuth) {
          reject(false);
          return;
        }

        this.GoogleAuth.grantOfflineAccess({ prompt: this.prompt })
          .then((resp) => {
            resolve(resp.code);
          })
          .catch((error) => {
            reject(error);
          })
      })
    };

    this.signOut = () => {
      return new Promise((resolve, reject) => {
        if (!this.GoogleAuth) {
          reject(false);
          return;
        }

        this.GoogleAuth.signOut()
          .then(() => {
            this.isAuthorized = false;
            this.app.$root.$emit("google-logged-out", null);
            resolve(true);
          })
          .catch((error) => {
            this.app.$root.$emit("error", error);
            reject(error);
          })
      })
    };

    this.getProfile = () => {
      let profile = this.isAuthorized && this.GoogleAuth.currentUser.get().getBasicProfile();

      return profile && {
        name: profile.getName(),
        mail: profile.getEmail(),
        photo: profile.getImageUrl(),
      };
    }
  }

  return new Auth();
})();




function installGoogleAuthPlugin(Vue, options) {
  /* eslint-disable */
  //set config
  let GoogleAuthConfig = null;
  let GoogleAuthDefaultConfig = {
    scope: 'profile email',
    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
  };

  let prompt = 'select_account';

  if (typeof options === 'object') {
    GoogleAuthConfig = Object.assign(GoogleAuthDefaultConfig, options);
    if (options.scope) {
      GoogleAuthConfig.scope = options.scope;
    }
    if (options.prompt) {
      prompt = options.prompt;
    }
    if (!options.clientId) {
      console.warn('clientId is required')
    }
  } else {
    console.warn('invalid option type. Object type accepted only')
  }

  // Vue.gAuth = googleAuth;
  Object.defineProperties(Vue.prototype, {
    $gAuth: {
      get() {
        return googleAuth;
      }
    }
  });

  // Vue.gAuth.load(GoogleAuthConfig, prompt);
  // googleAuth.load(GoogleAuthConfig, prompt);
  // Vue.attach(googleAuth, () => {
  //   googleAuth.load(GoogleAuthConfig, prompt);
  // });
  Vue.mixin({
    beforeCreate() {
      if (!googleAuth.app) {
        googleAuth.app = this;
        googleAuth.load(GoogleAuthConfig, prompt);
      }
    }
  });
}

export default installGoogleAuthPlugin;